import {FC} from 'react';
import cx from 'classnames';
import {FieldInputProps, FieldMetaProps} from 'formik';
import NumberFormat, {NumberFormatValues} from 'react-number-format';
import {preventExceedOfLimit} from 'core/utils';
import {THEMES} from 'shared/helpers';

import s from './NumericInput.module.scss';

type NumericInputProps = {
  id?: string;
  theme?: string;
  border?: string;
  name?: string;
  className?: string;
  width?: string;
  fullWidth?: boolean;
  label?: string;
  sign?: string;
  placeholder?: string;
  value?: string | number;
  options?: string | number;
  isValid?: boolean;
  color?: string;
  paddingLeft?: string;
  textAlign?: 'left' | 'center' | 'right';
  fontSize?: string;
  background?: 'none' | 'inherit' | 'transparent';
  reversed?: boolean;
  maxLength?: number;
  field?: FieldInputProps<any>;
  meta?: FieldMetaProps<any>;
  withIcon?: boolean;
  thousandSeparator?: boolean;
  preventionLimit?: number;
  decimalScale?: number;
  defaultValue?: string | number;
  allowNegative?: boolean;
  onValueChange?: (values: any) => void;
  onBlur?: any;
  setFieldValue?: (name: string, value: string | number | null, isValidated: boolean) => void;
};

const NumericInput: FC<NumericInputProps> = ({
  name,
  label,
  value,
  width,
  fullWidth = false,
  theme,
  border,
  color,
  sign,
  placeholder,
  preventionLimit,
  maxLength,
  isValid,
  defaultValue,
  field,
  meta,
  reversed,
  allowNegative,
  onValueChange,
  onBlur,
  thousandSeparator,
  textAlign = 'center',
  decimalScale = 2,
}) => (
  <div
    className={cx(s.numericInput, placeholder ? s.numericInput__withPlaceholder : '', {
      [s.numericInput_reversed]: reversed,
      [s.numericInput_white]: theme === THEMES.white,
      [s.numericInput_grey]: theme === THEMES.grey,
    })}
  >
    {label && <p className="FormSlide__inputLabel">{label}</p>}
    {placeholder && (
      <div className={cx(s.numericInput__placeholder, theme === THEMES.grey ? s.numericInput__placeholder_grey : '')}>
        {placeholder}
      </div>
    )}
    <NumberFormat
      {...field}
      name={name}
      onChange={(e: React.ChangeEvent) => field?.onChange(e) || onValueChange?.(e)}
      onBlur={onBlur}
      decimalScale={decimalScale}
      defaultValue={defaultValue}
      thousandSeparator={thousandSeparator}
      isAllowed={(data: NumberFormatValues) => (preventionLimit ? preventExceedOfLimit(data, preventionLimit) : true)}
      isNumericString
      value={value === '0' ? '' : value}
      allowNegative={allowNegative}
      maxLength={maxLength}
      style={{
        textAlign,
        width: fullWidth ? '100%' : width,
        background: theme === THEMES.white ? 'none' : '',
        border,
        color,
      }}
      className={cx(s.numericInput__item, {inputValid: isValid ?? (!meta?.error && (meta?.touched || field?.value))})}
    />
    {sign && <p className={cx(s.numericInput__sign, {[s.numericInput__sign_reversed]: reversed})}>{sign}</p>}
  </div>
);

export default NumericInput;
